import React from "react";
import {map} from "lodash";
import { Card, CardText } from "react-md";
import AtollonLogo from "../../src/assets/img/atollon-logo-black.png";
import AtollonLogoThumb from "../../src/assets/img/atollon-thumb.png";
import Carousel from "../../src/components/Carousel";

/**
 * @param history ... (passed)
 * @param organizationArray ...
 * @param gotoAdminPage ... go to different location on admin pages
 */
export const TouchOrganizations = ({ organizationArray, gotoAdminPage, history }) =>
{
    if( 1 )
    {
        return (
            <div style={{textAlign: "center"}}>
                {map( organizationArray, (c, i) => {
                    let name = c.name;
                    const uniqueKey = i;
                    return (
                        <div key={uniqueKey} style={{display: 'inline-block'}}>
                            <Card
                                raise
                                className="carousel-card"
                                key={`org${i}`}
                                onClick={() => {
                                    if( gotoAdminPage )
                                    {
                                        history.push(`/settings/organization/${c.identifier}`)
                                    }
                                    else
                                    {
                                        history.push(`/${c.identifier}`)
                                    }
                                }}
                            >
                                <CardText className="card-text">
                                    <p className="card-name">{name}</p>
                                    <p className="card-web">({c.identifier})</p>
                                    <img className="card-img" src={AtollonLogo} alt="logo" />
                                </CardText>
                            </Card>
                        </div>
                    )}
                )}
            </div>
        );
    }
    else
    {
        return (
            <Carousel>
                {map( organizationArray, (c, i) => (
                    <Card
                        raise
                        className="carousel-card"
                        key={`org${i}`}
                        onClick={() =>
                            history.push(`/settings/organization/${c.identifier}`)}
                    >
                        <CardText className="card-text">
                            <p className="card-web">{c.name}</p>
                            <img className="card-img" src={AtollonLogo} alt="logo" />
                        </CardText>
                    </Card>
                ))}
            </Carousel>
        );
    }
};


// WEBPACK FOOTER //
// ./src/Atollon/Organizations.js